export default __webpack_public_path__ + "static/media/TCD.faf47b29.svg";